import { render } from "./Scenes.vue?vue&type=template&id=8ab32dc2"
import script from "./Scenes.vue?vue&type=script&lang=js"
export * from "./Scenes.vue?vue&type=script&lang=js"
script.render = render

export default script